import { JSX } from "react";

export const Location = (): JSX.Element => {
    return (
        <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6 8C6.4125 8 6.76563 7.85313 7.05938 7.55938C7.35313 7.26563 7.5 6.9125 7.5 6.5C7.5 6.0875 7.35313 5.73438 7.05938 5.44063C6.76563 5.14687 6.4125 5 6 5C5.5875 5 5.23438 5.14687 4.94063 5.44063C4.64687 5.73438 4.5 6.0875 4.5 6.5C4.5 6.9125 4.64687 7.26563 4.94063 7.55938C5.23438 7.85313 5.5875 8 6 8ZM6 13.5125C7.525 12.1125 8.65625 10.8406 9.39375 9.69687C10.1313 8.55312 10.5 7.5375 10.5 6.65C10.5 5.2875 10.0656 4.17188 9.19687 3.30312C8.32812 2.43438 7.2625 2 6 2C4.7375 2 3.67188 2.43438 2.80312 3.30312C1.93438 4.17188 1.5 5.2875 1.5 6.65C1.5 7.5375 1.86875 8.55312 2.60625 9.69687C3.34375 10.8406 4.475 12.1125 6 13.5125ZM6 15.5C3.9875 13.7875 2.48438 12.1969 1.49063 10.7281C0.496875 9.25937 0 7.9 0 6.65C0 4.775 0.603125 3.28125 1.80938 2.16875C3.01563 1.05625 4.4125 0.5 6 0.5C7.5875 0.5 8.98438 1.05625 10.1906 2.16875C11.3969 3.28125 12 4.775 12 6.65C12 7.9 11.5031 9.25937 10.5094 10.7281C9.51562 12.1969 8.0125 13.7875 6 15.5Z"
                fill="#1D2D58"
            />
        </svg>
    );
};
